import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2415baa7")

_pushScopeId("data-v-2415baa7")
const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_3 = { class: "text-red-lp-100" }
const _hoisted_4 = {
  class: "absolute inset-y-0 right-0 flex items-center px-2",
  style: {"cursor":"pointer"}
}
const _hoisted_5 = {
  class: "w-full absolute z-50",
  style: {"border-bottom":"85px solid transparent"}
}
const _hoisted_6 = {
  key: 0,
  class: "flex justify-end p-2"
}
const _hoisted_7 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }, " Suffix ", -1)
const _hoisted_9 = { class: "pl-2.5 py-2 space-y-2" }
const _hoisted_10 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }, " Status ", -1)
const _hoisted_12 = { class: "space-y-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: 
      `advanced-filter inline-block relative bottom-0 left-0 text-12px xxl:text-14px mr-2 ${_ctx.openFilter &&
        'w-300px'}`
    
  }, [
    _createVNode("div", {
      class: 
        `bg-white ${
          _ctx.openFilter && !_ctx.isDisabled ? 'rounded-t' : 'rounded'
        } border border-gray-lp-400 text-black-lp-300 leading-tight px-3 py-2.5 xxl:py-2.5 pr-8 font-normal`
      ,
      style: {"cursor":"pointer"},
      onClick: _cache[2] || (_cache[2] = 
        () => {
          _ctx.openFilter = !_ctx.openFilter;
          _ctx.$emit('opened', _ctx.openFilter);
        }
      )
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", {
          class: _ctx.isDisabled && 'opacity-50'
        }, [
          _hoisted_2,
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.sumFilter ? `(${_ctx.sumFilter})` : ""), 1)
        ], 2)
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.openFilter)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _imports_0,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              alt: "up"
            }, null, 2))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              src: _imports_1,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.isChevron = true;
            }
          ),
              alt: "down"
            }, null, 2))
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_5, [
      _createVNode("div", {
        class: 
          `select bg-white border border-t-0 border-gray-lp-400 rounded-b-md px-4 ${_ctx.isScroll &&
            'overflow-y-auto'} overflow-x-show`
        
      }, [
        (_ctx.sumFilter > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetfilter && _ctx.resetfilter(...args))),
                class: "cursor-pointer flex-initial items-end text-red-lp-100"
              }, " Reset ")
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_custom_dropdown, {
            placeholder: "Pilih",
            value: 
              _ctx.filterData.suffix.length
                ? `${_ctx.filterData.suffix.length} Suffix`
                : ''
            
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_9, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.suffixOptions, (suffix, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "p-field-checkbox mt-1"
                  }, [
                    _createVNode(_component_Checkbox, {
                      name: "suffix",
                      id: index,
                      value: suffix.value,
                      modelValue: _ctx.filterData.suffix,
                      "onUpdate:modelValue": ($event: any) => (_ctx.filterData.suffix = $event),
                      onClick: _ctx.onChange
                    }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "onClick"]),
                    _createVNode("label", {
                      for: index,
                      class: "ml-2.5"
                    }, _toDisplayString(suffix.name), 9, ["for"])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("div", _hoisted_12, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (status, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "p-field-checkbox mt-1 space-y-1"
              }, [
                _createVNode(_component_Checkbox, {
                  name: "status",
                  id: index,
                  value: status.value,
                  modelValue: _ctx.filterData.status,
                  "onUpdate:modelValue": ($event: any) => (_ctx.filterData.status = $event),
                  onClick: _ctx.onChange
                }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "onClick"]),
                _createVNode("label", {
                  for: index,
                  class: "ml-2.5"
                }, _toDisplayString(status.name), 9, ["for"])
              ]))
            }), 128))
          ])
        ]),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 2)
    ], 512), [
      [_vShow, _ctx.openFilter && !_ctx.isDisabled]
    ])
  ], 2)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.openFilter = true;
          _ctx.$emit('opened', true);
          _ctx.isChevron = false;
        } else if (_ctx.openFilter) {
          _ctx.openFilter = false;
          _ctx.$emit('opened', false);
        }
      }
    ]
  ])
})